function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';
import componentPropType from '@signal/prop-types/component';
import formatPropType from '@signal/prop-types/format';
import getStringFormatter from '@signal/utils/getStringFormatter';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, Section, Label, LabelWrapper, Metric, Heading, MetricWrapper } from './styles';
export var dataListItemsPropType = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  format: formatPropType.isRequired,
  heading: PropTypes.string,
  comparison: PropTypes.shape({
    inverted: PropTypes.bool,
    // TODO: remove this when inverted is retired
    perspective: PropTypes.string,
    data: PropTypes.object
  })
}));
export var DataList = function DataList(_ref) {
  var items = _ref.items,
      labelProps = _ref.labelProps,
      sectionProps = _ref.sectionProps,
      typographyColor = _ref.typographyColor,
      typographyVariant = _ref.typographyVariant,
      style = _ref.style,
      className = _ref.className,
      MetricComponent = _ref.metricComponent,
      metricComponentProps = _ref.metricComponentProps;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      maxMetricWidth = _useState2[0],
      setMaxMetricWidth = _useState2[1];

  var maxMetricWidthRef = useRef(); // if we are right aligned, we need to ensure that all metrics have the same width so that the right-aligned
  // labels will line up

  var setRef = function setRef(ref) {
    if (ref && labelProps.alignRight) {
      var metricWidth = ref.getBoundingClientRect().width; // we need to use a reference because the state update cycle is not guaranteed to happen between each setRef
      // callback, so we need to ensure the number we compare against below is not stale

      if (!isNumber(maxMetricWidthRef.current)) {
        maxMetricWidthRef.current = 0;
      }

      if (metricWidth > maxMetricWidthRef.current) {
        maxMetricWidthRef.current = metricWidth;
        setMaxMetricWidth(metricWidth);
      }
    }
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    style: style,
    className: className
  }, items.map(function (item, key) {
    var metricLabel = item.label,
        format = item.format,
        value = item.value,
        _item$heading = item.heading,
        heading = _item$heading === void 0 ? '' : _item$heading;
    var metricKey = "".concat(heading, ":").concat(metricLabel, "_").concat(key);
    var metricValue = getStringFormatter(format)(value);
    return /*#__PURE__*/React.createElement(Section, Object.assign({
      key: metricKey
    }, sectionProps), /*#__PURE__*/React.createElement(LabelWrapper, labelProps, renderIf(heading, function () {
      return /*#__PURE__*/React.createElement(Heading, null, heading);
    }), /*#__PURE__*/React.createElement(Label, Object.assign({
      color: typographyColor,
      variant: typographyVariant
    }, labelProps), metricLabel)), /*#__PURE__*/React.createElement(MetricWrapper, Object.assign({}, labelProps, {
      metricWidth: maxMetricWidth,
      ref: setRef
    }), renderIf(MetricComponent, function () {
      return /*#__PURE__*/React.createElement(MetricComponent, Object.assign({}, item, metricComponentProps));
    }, /*#__PURE__*/React.createElement(Metric, {
      color: typographyColor,
      variant: typographyVariant
    }, metricValue))));
  }));
};
DataList.propTypes = {
  items: dataListItemsPropType.isRequired,
  labelProps: PropTypes.object,
  typographyColor: PropTypes.string,
  typographyVariant: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  metricComponent: componentPropType,
  metricComponentProps: PropTypes.object
};
DataList.defaultProps = {
  items: [],
  labelProps: {},
  typographyVariant: 'body2'
};
export default DataList;